// TODO Fix everything with eslint-disable-next-line @typescript-eslint/no-redeclare
import * as types from 'types';
import { uiTypes } from 'shared-components';
import { IOffer } from 'types';
import { OfferState } from './../store/student/offer/types';
export type IModal = uiTypes.IModal;
export type IDate = uiTypes.IDate;
export type ICheckbox = uiTypes.ICheckbox;
export type IQuestion = uiTypes.IQuestion;

export const UploadFileStatus = uiTypes.UploadFileStatus;
// eslint-disable-next-line @typescript-eslint/no-redeclare
export type UploadFileStatus = uiTypes.UploadFileStatus;

export const DocStatusType = types.DocStatusType;
// eslint-disable-next-line @typescript-eslint/no-redeclare
export type DocStatusType = types.DocStatusType;

export const FollowUpDocStatusType = types.FollowUpDocStatusType;
// eslint-disable-next-line @typescript-eslint/no-redeclare
export type FollowUpDocStatusType = types.FollowUpDocStatusType;

export const SectionStatusType = types.SectionStatusType;
// eslint-disable-next-line @typescript-eslint/no-redeclare
export type SectionStatusType = types.SectionStatusType;

export const RegionConfigType = types.RegionConfigType;
// eslint-disable-next-line @typescript-eslint/no-redeclare
export type RegionConfigType = types.RegionConfigType;

export const DocAccessType = types.DocAccessType;
// eslint-disable-next-line @typescript-eslint/no-redeclare
export type DocAccessType = types.DocAccessType;

export interface IAnyObj {
  [key: string]: any;
}
export interface IOtherNationality {
  nationality: string;
  isCurrent?: boolean;
}

export interface ICountry {
  name: string;
  atas: boolean;
  tb: boolean;
  riskLevel: number;
}

export interface IOtherName {
  surname: string;
  givenName: string;
  reason: string;
}

export interface IStudentVisa {
  visaType: string;
  level: string;
  year: string;
  isComplete?: boolean;
  incompleteReason?: string;
  isIncompleteRecorded?: boolean;
  isVisaShortened?: boolean;
  shortenedDate?: string;
}

export interface IStudentOtherVisa {
  visaType: string;
  year: string;
}
export interface IStudentVisaRefusal {
  visaType: string;
  year: string;
}

export interface IStudentNonUKVisaRefusal {
  country: string;
  isStudentVisa?: boolean;
  year: string;
}
export interface PreviousVisa {
  type: string;
  year: string;
}

export interface PreviousStudyVisa extends types.StudyVisa {
  [key: string]: string | IDate | boolean | undefined;
}

export type IDocument = types.IDocument;

export interface IEvidenceOfIncomeDoc extends IDocument {
  currentEmploymentStatus?: string;
  fundSource?: string;
}

export interface DocumentMap {
  [key: string]: IDocument;
}
export interface IDocumentsList {
  key: string;
  item: IDocument;
}

export interface StudentVisaMap {
  [key: string]: StudentVisaDocuments;
}

export interface StudentVisaDocMap {
  [key: string]: StudentVisaDoc;
}

export interface StudentVisaDocList {
  key: string;
  item: StudyVisaDoc;
}

export type StudentVisaDocuments = types.StudentVisaDocuments;

export interface BiometricDocumentMap {
  [key: string]: BiometricDocument;
}

export interface BiometricDocumentList {
  key: string;
  item: BiometricDocument;
}

export type BiometricDocument = types.BiometricDocument;

export type PassportDocs = types.PassportDocs;

export interface PassportMap {
  [key: string]: PassportDoc;
}

export interface PassportList {
  key: string;
  item: PassportDoc;
}

export type PassportDoc = types.PassportDoc;

export interface StudentVisaDocList {
  key: string;
  item: StudentVisaDoc;
}

export type StudentVisaDoc = types.StudentVisaDoc;

export type VisaRefusalDoc = types.VisaRefusalDoc;

export interface UKVisaRefusalMap {
  [key: string]: UKVisaRefusal;
}

export interface VisaRefusalDocMap {
  [key: string]: VisaRefusalDoc;
}

export interface VisaRefusalDocList {
  key: string;
  item: VisaRefusalDoc;
}

export type UKVisaRefusal = types.UKVisaRefusal;

export interface NonUKVisaRefusalMap {
  [key: string]: NonUKVisaRefusal;
}

export type NonUKVisaRefusal = types.NonUkVisaRefusal;

export type OVisa = types.OtherVisa;

export type VisaRefusal = types.VisaRefusal;
export interface OtherVisaMap {
  [key: string]: OtherVisaDocs;
}

export interface OtherVisaList {
  key: string;
  item: OtherVisaDocs;
}

export type OtherVisaDocs = types.OtherVisaDocs;

export interface ParentalConsentMap {
  [key: string]: ParentalConsent;
}

export interface ParentalConsentList {
  key: string;
  item: ParentalConsent;
}

export type ParentalConsent = types.ParentalConsent;

export interface TBTestMap {
  [key: string]: TBTest;
}

export interface TBTestList {
  key: string;
  item: TBTest;
}

export type TBTest = types.TBTest;

export interface ATASMap {
  [key: string]: ATAS;
}

export interface ATASList {
  key: string;
  item: ATAS;
}

export type ATAS = types.ATAS;

export interface StudentRefusalLetterDocMap extends types.StudentRefusalLetterDocMap {
  [key: string]: types.StudentRefusalLetterDoc;
}
export interface VisaVignetteDocMap extends types.VisaVignetteDocMap {
  [key: string]: types.VisaVignetteDoc;
}
export type VisaApplicationPdfCopyDocMap = types.VisaApplicationPdfCopyDocMap;
export type TravelTicketDocMap = types.TravelTicketDocMap;

export interface IVisaApplicationPdfCopyDocumentsList {
  key: string;
  item: types.VisaApplicationPdfCopyDoc;
}

export interface CustomRequestMap {
  [key: string]: CustomRequest;
}

export interface CustomRequest extends types.CustomRequest {
  [key: string]: any;
}

export interface DepositDoc extends types.DepositDoc {
  [key: string]: any;
}

export type BirthCertificateDocs = types.BirthCertificateDocs;

export interface BirthCertificateDocMap {
  [key: string]: BirthCertificateDoc;
}
export interface BirthCertificateDocList {
  key: string;
  item: BirthCertificateDoc;
}

export type BirthCertificateDoc = types.BirthCertificateDoc;

export interface FamilySponsorshipDocMap {
  [key: string]: FamilySponsorshipDoc;
}

export interface BankStatementDocMap {
  [key: string]: BankStatementDoc;
}

export interface BankStatementDocList {
  key: string;
  item: BankStatementDoc;
}

export type BankStatementDoc = types.BankStatementDoc;

export interface ParentLetterDocMap {
  [key: string]: ParentLetterDoc;
}

export interface ParentLetterDocList {
  key: string;
  item: ParentLetterDoc;
}

export type ParentLetterDoc = types.ParentLetterDoc;

export interface BankLetterMap {
  [key: string]: BankLetterDoc;
}

export interface BankLetterList {
  key: string;
  item: BankLetterDoc;
}

export type BankLetterDoc = types.BankLetterDoc;

export type EvidenceOfIncomeDocs = types.EvidenceOfIncomeDocs;

export interface FamilySponsorshipDoc extends types.FamilySponsorshipDoc {
  [key: string]: any;
}

export interface OrganisationDocsMap {
  [key: string]: Organisation;
}

export interface Organisation extends types.Organisation {
  [key: string]: any;
}

export interface OrganisationDocMap {
  [key: string]: OrganisationDoc;
}

export interface OrganisationDocList {
  key: string;
  item: OrganisationDoc;
}

export type OrganisationDoc = types.OrganisationDoc;

export interface ScholarshipDocsMap {
  [key: string]: Scholarship;
}

export interface Scholarship extends types.Scholarship {
  [key: string]: any;
}

export interface ScholarshipDocMap {
  [key: string]: ScholarshipDoc;
}

export interface ScholarshipDocList {
  key: string;
  item: ScholarshipDoc;
}

export type ScholarshipDoc = types.ScholarshipDoc;

export interface EducationDocsMap {
  [key: string]: Education;
}

export interface Education extends types.Education {
  [key: string]: any;
}

export interface EducationDocMap {
  [key: string]: EducationDoc;
}

export interface EducationDocList {
  key: string;
  item: EducationDoc;
}

export type EducationDoc = types.EducationDoc;

export interface OtherDocMap {
  [key: string]: OtherDoc;
}

export interface OtherDoc {
  label: string;
  amount: number;
}

export type BiometricResidencePermitDocMap = types.BiometricResidencePermitDocMap;
export type BiometricResidencePermitDoc = types.BiometricResidencePermitDoc;
export type IConsents = types.IConsents;

export type IAgent = types.IAgent;

export interface IAgentFromAPI {
  displayName: string;
  masterAgent: string;
  username: string;
  email: string;
}

export type ICore = types.ICore;

export interface APICall {
  callName: string;
  retryNumber: number;
  timeToNextCall: number;
  hasFailed: boolean;
  error?: string;
}

export type IRegionConfig = types.IRegionConfig;
export const OptionStatusType = types.OptionStatusType;
// eslint-disable-next-line @typescript-eslint/no-redeclare
export type OptionStatusType = types.OptionStatusType;

export type IStudentConfig = Omit<types.IConfigDefault & types.IRegionConfig, 'university_code', 'university_name'> & {
  universityCode: string;
  universityName: string;
};

export type ICourse = types.ICourse;

export type IPersonalInfo = types.IPersonalInfo;
// eslint-disable-next-line @typescript-eslint/no-redeclare
export type IOffer = types.IOffer;

export type IHistory = types.IHistory;

export type FundingSummary = types.FundingSummary;

export type OrganisationSponsorshipMap = types.OrganisationSponsorshipMap;
export type OrganisationSponsorship = types.OrganisationSponsorship;
export type ScholarshipSponsorshipMap = types.ScholarshipSponsorshipMap;
export type ScholarshipSponsorship = types.ScholarshipSponsorship;
export type EducationSponsorshipMap = types.EducationSponsorshipMap;
export type EducationSponsorship = types.EducationSponsorship;
export type FamilySponsorshipMap = types.FamilySponsorshipMap;
export type FamilySponsorship = types.FamilySponsorship;
export const FamilySponsorType = types.FamilySponsorType;
// eslint-disable-next-line @typescript-eslint/no-redeclare
export type FamilySponsorType = types.FamilySponsorType;
export type OtherSponsorshipMap = types.OtherSponsorshipMap;
export type OtherSponsorship = types.OtherSponsorship;

export type IFinance = types.IFinance;

export interface ICountry {
  name: string;
  atas: boolean;
  tb: boolean;
}

export type IPreCasInterview = types.IPreCasInterview;
export type ITravelStatus = types.ITravelStatusSection;
export type IVisaStatus = types.VisaStatus;
export type IAccommodationStatus = types.IAccommodationStatusSection;

export type IEnrolmentStatus = types.IEnrolmentStatus;

export interface ISummary extends types.ISummary {
  [key: string]: any;
}

export type IAdditionalPassport = types.IAdditionalPassport;

export type IOtherUkVisas = types.IOtherUkVisas;

export type ITripToUk = types.ITripToUk;

export type IExclusionOrder = types.IExclusionOrder;

export type ILeaveToRemain = types.ILeaveToRemain;

export type IBorderRefusal = types.IBorderRefusal;

export type IDeportation = types.IDeportation;

export type IChildDetails = types.IChildDetails;

export const MaritalStatus = types.MaritalStatus;
// eslint-disable-next-line @typescript-eslint/no-redeclare
export type MaritalStatus = types.MaritalStatus;

export const Relationship = types.Relationship;
// eslint-disable-next-line @typescript-eslint/no-redeclare
export type Relationship = types.Relationship;

export type IOtherTravellers = types.IOtherTravellers;

export type IFamilyMember = types.IFamilyMember;

export type ITravelItems = types.ITravelItems;

export interface IPhone {
  code: string | null;
  phone: string | null;
}

export type IVisaPrepForm = types.IVisaPrepForm;
export type IDocuments = types.IDocuments;
export interface IVisa {
  core: ICore;
  offer: OfferState;
  personalInfo: IPersonalInfo;
  history: IHistory;
  financials: IFinance;
  consents: IConsents;
  visa: IVisaPrepForm;
  documents: IDocuments;
  financeDocuments: IFinanceDocuments;
  followUpDocuments: IFollowUpDocuments;
  enrolmentStatus: IEnrolmentStatus;
  preCasInterview: IPreCasInterview;
  summary: ISummary;
  messages: IMessage[];
  importData: IImportData;
  conflictHistory: IConflictHistory;
}

export type IConflictHistory = types.IConflictHistory;

export type IImportData = types.IImportData;

export type IImportCourse = types.IImportCourse;

export type IImportOffer = types.IImportOffer;

export interface ConfigField {
  label?: string;
  subLabel?: string;
  visible: boolean;
  mandatory: boolean;
  defaultValue?: any;
  helpText?: string | React.ReactNode;
}

export interface IPropertyUpdate {
  property: string;
  value: any;
}

export interface IFundingSourceText {
  id: string;
  label: string;
  button: string;
  buttonAlt: string;
  saveButtonText: string;
}

export interface IRestrictedBanks {
  [key: string]: IRestrictedBank[];
}

export interface IRestrictedBank {
  bank: string;
  isAccepted: boolean;
}

export type MfaSetupSettingsType = { mfaMethod: string; phoneNumber?: string };

export type IExceedRecordedInterview = {
  uni: string;
  interviewHash: string;
  interviewId: string;
  studentNumber: string;
  intakeId: string;
  offerId: strin;
  pathway?: string;
};
